import React, { useState, useEffect } from 'react';
import { ContentBox } from '../../Content/ContentBox';
import { SystemPromptInput } from '../../Res/SystemPrompt';
import { ReqUpdateSystemAccount, RespClientAdminDetail } from '../../../../item/ItemAccount';
import { SingleText, SingleRedio, isDisableItems, SingleInput } from '../../Res/BaseInput';
import { api_getSystemAccountDetail, api_updateSystemAccount } from '../../../../api/apiAccount';
import { api_getRoleList } from '../../../../api/apiCompany';
import { ListSelect } from '../../Res/ListSelect';
import { Swal2Button, CancelSubmitButton } from '../../Res/BaseButton';
import Swal from 'sweetalert2';

export function AccountDetail({ id, setIsLoading, isEdit }) {
    const [accountId, setAccountId] = useState(id)
    const [mRespAccountAdminDetail, setRespAccountAdminDetail] = useState(new RespClientAdminDetail())
    const [mDetailAccountRolesObj, setDetailAccountRolesObj] = useState([])
    const [mDetailAccountRoles, setDetailAccountRoles] = useState([])
    const [roles, setRoles] = useState([])

    const [isDisable, setisDisable] = useState("")
    const [mobile, setMobile] = useState("")
    const [nickName, setNickName] = useState("")
    const [note, setNote] = useState("")
    const [accountRoles, setAccountRoles] = useState([])

    useEffect(() => {
        if (isEdit) {
            getSystemRoleList()
        }
    }, [])

    useEffect(() => {
        if (id !== undefined && id !== accountId) {
            setAccountId(id)
        }
    }, [id])

    useEffect(() => {
        console.log("api_getAdminDetail")
        setIsLoading(true)
        api_getSystemAccountDetail({
            accountId,
            success: (result) => {
                console.log(result)
                var detail = new RespClientAdminDetail()
                detail.fromJson(result.detail)
                //console.log(result.roles)
                setRespAccountAdminDetail(detail)
                setDetailAccountRolesObj(result.roles)
                var roles = []
                result.roles.map(role => {
                    roles.push(role.roleId)
                })
                console.log(roles)
                setAccountRoles(roles)
                setDetailAccountRoles(roles)
                setisDisable(detail.isDisable)
                setMobile(detail.mobile)
                setNickName(detail.nickName)
                setNote(detail.note)
                setIsLoading(false)
            },
            failure: (err) => {
                console.log(err)
                setIsLoading(false)
            }
        })
    }, [accountId])

    function getSystemRoleList() {
        api_getRoleList({
            departmentId: "admin",
            success: (result) => {
                //console.log(result)
                setRoles(result.list)
            },
            failure: (err) => {
                console.log(err)
            }
        })
    }

    function toEdit() {
        window.location.assign("/AccountEdit/" + accountId);
    }

    function toCancel() {
        window.history.go(-2)
    }

    function toReload() {
        window.location.reload()
    }

    function saveDetail() {
        //console.log(accountRoles)
        //console.log(mDetailAccountRoles)

        let add = accountRoles.filter((e) => {
            return mDetailAccountRoles.indexOf(e) === -1
        })

        let cut = mDetailAccountRoles.filter((e) => {
            return accountRoles.indexOf(e) === -1
        })

        var mReqUpdateSystemAccount = new ReqUpdateSystemAccount({
            accountId,
            mobile,
            nickName,
            note,
            isDisable: isDisable === mRespAccountAdminDetail.isDisable ? undefined : isDisable,
            addAccountRoles: add,
            cutAccountRoles: cut
        })
        api_updateSystemAccount({
            mReqUpdateSystemAccount,
            success: (jsonData) => {
                //console.log(jsonData)
                Swal2Button({
                    confirmAction: toReload,
                    cancelButtonText: "返回列表",
                    cancelAction: toCancel
                })
            },
            failure: (err) => {
                Swal.fire({
                    type: 'error',
                    title: '提醒',
                    text: err.message
                })
            }
        })
    }

    var title = '帳號檢視'
    var title_tools =
        isEdit ? <></> :
            <a className="dropdown-toggle " onClick={e => toEdit()} data-toggle="dropdown" href="#A">
                <i class="fa fa-pencil text-warning"></i><span class="text-warning m-l-xs">編輯</span>
            </a>
    var content =
        <><div class="row">
            <div class="col-md-12">
                {isEdit ?
                    <SingleRedio title={"啟用狀態"}
                        arr={isDisableItems}
                        val={isDisable} action={setisDisable} />
                    : <SingleText title={"啟用狀態"} val={isDisable === "" ? "" : isDisable === 1 ? "停用中" : "啟用中"} size={4} />
                }
                <SingleText title={"最近啟用日期"} val={"-"} size={4} />
                <SingleText title={"最近停用日期"} val={"-"} size={4} />
            </div>
        </div>
            <div class="hr-line-dashed"></div>
            <div class="row">
                <div class="col-md-12">
                    {isEdit ?
                        <SingleInput title={"帳號"} val={mobile} action={setMobile} size={4} />
                        :
                        <SingleText title={"帳號"} val={mobile} size={4} />
                    }
                    {isEdit ?
                        <SingleInput title={"暱稱"} val={nickName} action={setNickName} size={4} />
                        :
                        <SingleText title={"暱稱"} val={nickName} size={4} />
                    }
                    {isEdit ?
                        <SingleInput title={"註記"} val={note} action={setNote} size={4} />
                        :
                        <SingleText title={"註記"} val={note} size={4} />
                    }
                </div>
            </div>
            <div class="hr-line-dashed"></div>
            <div class="row">
                <div class="col-md-12">
                    {isEdit ?
                        <ListSelect
                            title={"角色"}
                            ids={accountRoles}
                            list={roles}
                            sId={"roleId"}
                            sName={"roleName"}
                            setIds={setAccountRoles}
                        />
                        :
                        <SingleText title={"角色"} val={Object.values(mDetailAccountRolesObj).map(item => item.roleName).join(", ")} size={12} />
                    }
                </div>
            </div>
        </>
    var footer = <>
        {isEdit ?
            <div className="row">
                <div className="col-sm-3 col-sm-offset-9">
                    <CancelSubmitButton cancelAction={toCancel} submitName={"儲存"} submitAction={saveDetail} isRight={true} />
                </div>
            </div>
            : <></>
        }
    </>
    return (
        <>
            <ContentBox title={title} title_tools={title_tools} content={content} footer={footer} hasDrawer={false} />
            <SystemPromptInput />
        </>
    )
}